module.exports = __webpack_public_path__ + "media/button.a686138b.wav";